import { Network } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { aiGatewayWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  aiGatewayWeb,
  {
    AiGatewaysPage: () => import('./AiGatewaysPage'),
    AiGatewayAttachmentPicker: () => import('./AiGatewayAttachmentPicker'),
    AiGatewayAttachmentSummary: () => import('./AiGatewayAttachmentSummary'),
    AiGatewayMentionProvider: () => import('./AiGatewayMentionProvider'),
    AiGatewayMentionCreate: () =>
      import('./AiGatewayMentionCreate').then((m) => ({ default: m.AiGatewayMentionCreate })),
    AiGatewayDetailSection: () => import('./AiGatewayDetailSection'),
    AiGatewayPreview: () =>
      import('./AiGatewayPreview').then((m) => ({ default: m.AiGatewayPreview })),
    AiGatewaysCardPreview: () =>
      import('./AiGatewaysCardPreview').then((m) => ({ default: m.AiGatewaysCardPreview })),
  },
  {
    icons: { Network },
  },
);
